export default "__VITE_ASSET__DXNhHroL__"